/* pg-cards.js — споделено поведение за pg-card каруселите (featured / related / recently-viewed).
   Swatches + Add to Cart са пренесени 1:1 от premium-product-grid. Закача се на всеки
   контейнер [data-pg-cards]; конфигът идва от data-* атрибутите. */
(function () {
  'use strict';

  var PG_ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  function pgURL(p) { return PG_ROOT.replace(/\/$/, '') + p; }
  function esc(s) { return String(s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
  function cdn(src, w) {
    if (!src) return '';
    var q = src.indexOf('?'), base = q !== -1 ? src.slice(0, q) : src, qs = q !== -1 ? src.slice(q) : '';
    base = base.replace(/_\d+x(\d+)?(?=\.(jpg|jpeg|png|gif|webp|avif))/i, '');
    var sized = base.replace(/\.(jpg|jpeg|png|gif|webp|avif)$/i, '_' + w + 'x.$1');
    return sized === base ? src : sized + qs;
  }
  var variantCache = {};

  function initContainer(root) {
    if (!root || root.dataset.pgCardsBound === '1') return;
    root.dataset.pgCardsBound = '1';

    var IS_BG     = root.dataset.isBg === 'true';
    var BGN_RATE  = parseFloat(root.dataset.bgnRate) || 1.95583;
    var ATC_LABEL = root.dataset.lblAtc || 'Add to Cart';
    var SOLD_OUT  = root.dataset.lblSoldout || 'Sold Out';
    var ADDED_LBL = root.dataset.lblAdded || '✓ Added';
    var TRY_AGAIN = root.dataset.lblTryagain || 'Try again';
    var SWATCH_STYLE = root.dataset.swatchStyle || 'color';

    /* Изчерпаните артикули най-отзад (стабилно — пази реда на наличните) */
    Array.prototype.slice.call(root.children).forEach(function (w) {
      if (w.querySelector && w.querySelector('.pg-badge--sold')) root.appendChild(w);
    });

    var eurFmt;
    try { eurFmt = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 2 }); } catch (e) {}
    function fmtEur(c) { return eurFmt ? eurFmt.format(c / 100) : '€' + (c / 100).toFixed(2).replace('.', ','); }
    function fmtBgn(c) { return ((c / 100) * BGN_RATE).toFixed(2).replace('.', ',') + ' лв'; }
    function priceHTML(c) { var h = fmtEur(c); if (IS_BG) h += '<span class="price-bgn">' + fmtBgn(c) + '</span>'; return h; }

    /* ── SWATCHES (lazy via /products/{handle}.js при hover/touch) ── */
    root.querySelectorAll('[data-swatches]').forEach(function (sw) {
      var card = sw.closest('.pg-card-wrap');
      var handle = sw.dataset.handle;

      function initSwatches(productData) {
        if (!productData) return;
        var variants = productData.variants || [];
        var images = productData.images || [];
        if (!variants.length) return;
        var imgMap = {};
        images.forEach(function (img) { imgMap[img.id] = img.src; });
        variants.forEach(function (v) {
          if (!v.featured_image && v.featured_image_id) v.featured_image = { src: imgMap[v.featured_image_id] || null };
          if (v.featured_image && !v.featured_image.src && v.featured_image.id) v.featured_image.src = imgMap[v.featured_image.id] || null;
        });
        var seen = {}, sws = [];
        variants.forEach(function (v) { if (v.option1 && !seen[v.option1]) { seen[v.option1] = true; sws.push(v); } });
        sw.innerHTML = sws.slice(0, 8).map(function (v, i) {
          var col = v.option1.toLowerCase().replace(/\s+/g, '');
          return '<button class="pg-swatch' + (i === 0 ? ' is-active' : '') + '" type="button" data-o1="' + esc(v.option1) + '" title="' + esc(v.option1) + '" style="background:' + col + '">' +
            (SWATCH_STYLE === 'text' ? esc(v.option1).substring(0, 4) : '') + '</button>';
        }).join('') + (sws.length > 8 ? '<span class="pg-swatch pg-swatch--more">+' + (sws.length - 8) + '</span>' : '');
        sw.dataset.loaded = '1';
        var productImages = images;
        sw.querySelectorAll('[data-o1]').forEach(function (btn) {
          btn.addEventListener('click', function (e) {
            e.preventDefault(); e.stopPropagation();
            var o1 = btn.dataset.o1;
            var v = variants.find(function (v) { return v.option1 === o1 && v.available; }) || variants.find(function (v) { return v.option1 === o1; });
            if (!v) return;
            sw.querySelectorAll('[data-o1]').forEach(function (b) { b.classList.toggle('is-active', b === btn); });
            var imgEl = card.querySelector('[data-product-img]');
            if (imgEl) {
              var imgSrc = null;
              if (v.featured_image && v.featured_image.src) imgSrc = v.featured_image.src;
              else if (v.featured_image && v.featured_image.id && imgMap[v.featured_image.id]) imgSrc = imgMap[v.featured_image.id];
              if (!imgSrc && productImages && productImages.length) { var pos = (v.position || 1) - 1; if (productImages[pos]) imgSrc = productImages[pos].src; }
              if (imgSrc) { imgEl.src = cdn(imgSrc, 600); imgEl.srcset = cdn(imgSrc, 400) + ' 400w,' + cdn(imgSrc, 600) + ' 600w,' + cdn(imgSrc, 800) + ' 800w'; }
            }
            var priceEl = card.querySelector('[data-card-price]'), compareEl = card.querySelector('.pg-card__compare');
            var badgesEl = card.querySelector('.pg-card__badges'), atcBtn = card.querySelector('[data-pg-atc]');
            var p = parseInt(v.price, 10) || 0, c = parseInt(v.compare_at_price || 0, 10) || 0;
            if (priceEl) priceEl.innerHTML = priceHTML(p);
            if (compareEl) { if (c > p) { compareEl.innerHTML = priceHTML(c); compareEl.style.display = ''; } else { compareEl.innerHTML = ''; compareEl.style.display = 'none'; } }
            if (badgesEl) {
              var sb = badgesEl.querySelector('.pg-badge--sale');
              if (c > p) { var pct = Math.round((c - p) * 100 / c); if (!sb) { sb = document.createElement('span'); sb.className = 'pg-badge pg-badge--sale'; badgesEl.appendChild(sb); } sb.textContent = '-' + pct + '%'; sb.style.display = ''; }
              else if (sb) { sb.style.display = 'none'; }
            }
            if (atcBtn) {
              atcBtn.dataset.vid = v.id;
              if (v.available) { atcBtn.disabled = false; atcBtn.textContent = ATC_LABEL; atcBtn.classList.remove('pg-card__atc--soldout'); }
              else { atcBtn.disabled = true; atcBtn.textContent = SOLD_OUT; atcBtn.classList.add('pg-card__atc--soldout'); }
            }
          });
        });
      }
      function loadVariants() {
        if (sw.dataset.loaded === '1') return;
        sw.dataset.loaded = '1';
        if (variantCache[handle]) { initSwatches(variantCache[handle]); return; }
        fetch(pgURL('/products/' + handle + '.js')).then(function (r) { return r.json(); }).then(function (data) { variantCache[handle] = data; initSwatches(data); }).catch(function () {});
      }
      var c = sw.closest('.pg-card');
      c.addEventListener('mouseenter', loadVariants, { once: true });
      c.addEventListener('touchstart', loadVariants, { once: true, passive: true });
    });

    /* ── ADD TO CART ── */
    root.querySelectorAll('[data-pg-atc]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var vid = parseInt(btn.dataset.vid, 10);
        if (!vid || btn.disabled) return;
        btn.disabled = true; btn.textContent = '...';
        fetch(pgURL('/cart/add.js'), { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify({ id: vid, quantity: 1 }) })
          .then(function (r) { return r.json(); })
          .then(function () {
            btn.textContent = ADDED_LBL; btn.classList.add('pg-card__atc--added');
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            document.dispatchEvent(new CustomEvent('cart:open'));
            document.dispatchEvent(new CustomEvent('theme:cart:open'));
            fetch(pgURL('/cart.js')).then(function (r) { return r.json(); }).then(function (cart) {
              document.querySelectorAll('[data-cart-count],[data-cart-item-count],.cart-count-bubble span,.cart-icon-bubble-count,.cart__count').forEach(function (el) { if (el.tagName === 'INPUT') el.value = cart.item_count; else el.textContent = cart.item_count; });
              var triggers = ['[data-cart-toggle]', '[data-cart-icon-bubble]', '[aria-controls="CartDrawer"]', '[aria-controls="cart-notification"]', '[aria-controls="MiniCart"]', '[aria-controls="cart-drawer"]', '.js-drawer-open-cart', '#cart-icon-bubble', '.cart-trigger', '[data-open-cart]', '[data-cart-open]', '.site-header__cart', '[href="/cart"]'];
              for (var i = 0; i < triggers.length; i++) { var el = document.querySelector(triggers[i]); if (el) { el.click(); break; } }
            }).catch(function () {});
            setTimeout(function () { btn.disabled = false; btn.textContent = ATC_LABEL; btn.classList.remove('pg-card__atc--added'); }, 2200);
          })
          .catch(function () { btn.disabled = false; btn.textContent = TRY_AGAIN; });
      });
    });

    /* ── СТРЕЛКИ на карусела ── */
    var wrap = root.closest('.pg-carousel-wrap');
    if (wrap && wrap.dataset.pgArrowsBound !== '1') {
      wrap.dataset.pgArrowsBound = '1';
      var prev = wrap.querySelector('[data-pg-prev]'), next = wrap.querySelector('[data-pg-next]');
      function step() { var card = root.querySelector('.pg-card-wrap'); return card ? card.getBoundingClientRect().width + 16 : root.clientWidth * 0.8; }
      if (prev) prev.addEventListener('click', function () { root.scrollBy({ left: -step() * 2, behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { root.scrollBy({ left: step() * 2, behavior: 'smooth' }); });
      function updateArrows() {
        var max = root.scrollWidth - root.clientWidth - 2;
        if (prev) prev.classList.toggle('is-hidden', root.scrollLeft <= 2);
        if (next) next.classList.toggle('is-hidden', root.scrollLeft >= max || max <= 0);
      }
      root.addEventListener('scroll', updateArrows, { passive: true });
      updateArrows();
    }
  }

  /* ── You may also like (Shopify recommendations) ── */
  function loadRecommendations() {
    document.querySelectorAll('[data-pg-recommendations]').forEach(function (el) {
      if (el.dataset.pgRecLoaded === '1') return;
      if (el.querySelector('[data-pg-cards]')) { el.dataset.pgRecLoaded = '1'; return; } /* вече рендирано server-side */
      el.dataset.pgRecLoaded = '1';
      var pid = el.dataset.productId, sid = el.dataset.sectionId, intent = el.dataset.intent || 'related', limit = el.dataset.limit || 10;
      if (!pid) { el.style.display = 'none'; return; }
      fetch(pgURL('/recommendations/products?section_id=' + encodeURIComponent(sid) + '&product_id=' + pid + '&limit=' + limit + '&intent=' + intent))
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-pg-recommendations]');
          if (fresh && fresh.querySelector('[data-pg-cards]')) { el.innerHTML = fresh.innerHTML; boot(); }
          else { el.style.display = 'none'; }
        })
        .catch(function () { el.style.display = 'none'; });
    });
  }

  /* ── Recently viewed (localStorage по handle) ── */
  var RV_KEY = 'pg_recently_viewed';
  function recordRV(handle) {
    if (!handle) return;
    try {
      var a = JSON.parse(localStorage.getItem(RV_KEY) || '[]');
      a = a.filter(function (x) { return x && x !== handle; });
      a.unshift(handle);
      localStorage.setItem(RV_KEY, JSON.stringify(a.slice(0, 20)));
    } catch (e) {}
  }
  function loadRecentlyViewed() {
    document.querySelectorAll('[data-pg-recently]').forEach(function (el) {
      if (el.dataset.pgRvLoaded === '1') return;
      el.dataset.pgRvLoaded = '1';
      var current = el.dataset.currentHandle || '';
      var cardSec = el.dataset.cardSection || 'pg-card-render';
      var limit = parseInt(el.dataset.limit, 10) || 10;
      if (current) recordRV(current);
      var handles = [];
      try { handles = JSON.parse(localStorage.getItem(RV_KEY) || '[]'); } catch (e) {}
      handles = handles.filter(function (h) { return h && h !== current; }).slice(0, limit);
      var listEl = el.querySelector('[data-pg-rv-list]');
      if (!handles.length || !listEl) { el.style.display = 'none'; return; }
      Promise.all(handles.map(function (h) {
        return fetch(pgURL('/products/' + h + '?section_id=' + cardSec))
          .then(function (r) { return r.text(); })
          .then(function (html) { return new DOMParser().parseFromString(html, 'text/html').querySelector('.pg-card-wrap'); })
          .catch(function () { return null; });
      })).then(function (cards) {
        var any = false;
        cards.forEach(function (c) { if (c) { listEl.appendChild(c); any = true; } });
        if (!any) { el.style.display = 'none'; return; }
        el.style.display = '';  /* показваме секцията чак когато има карти */
        listEl.setAttribute('data-pg-cards', '');  /* промотираме → initContainer го връзва */
        initContainer(listEl);
      });
    });
  }

  function boot() {
    document.querySelectorAll('[data-pg-cards]').forEach(initContainer);
    loadRecommendations();
    loadRecentlyViewed();
  }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();
